import axios from "../../../axios"
import { getCurrentTenant, parseObjectParamsToString } from '@/utils'

export default {
  fetch(searchFilter = '') {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          users (
            search_filter: "${searchFilter}"
          ) {
            id,
            email,
            name,
            image,
            username,
            attempts,
            blocked_at,
            from_alpha7,
            role {
              id,
              name,
              display_name,
              has_permission_routes
            },
            isConnected,
            userDepartment {
              id,
              name,
              activated 
            }
          }
        }
      `
    })
  },
  fetchPaginated(searchParams) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          paginatedUsers ${parseObjectParamsToString(searchParams)} {
            total_pages,
            total_items,
            items {
              id,
              email,
              name,
              image,
              username,
              unseenMsg,
            }
          }
        }
      `
    })
  },
  add(user) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    user.chosenInstances = user.chosenInstances ? user.chosenInstances : []
    return axios.post('', {
      query: `
        mutation {
          newUser (
            username: "${user.username}",
            name: "${user.name}",
            email: "${user.email}",
            password: "${user.password}",
            role_id: ${user.role.id},
            user_department_id: ${user.userDepartment.id},
            chosen_instances: [${user.chosenInstances.join(',')}]
          ) {
            user {
              id,
              email,
              name,
              image,
              username,
              isConnected,
              role {
                id,
                name,
                display_name,
                has_permission_routes
              },
              userDepartment {
                id,
                name,
                activated 
              }
            }
          }
        }
      `
    })
  },
  update(user) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    user.chosenInstances = user.chosenInstances ? user.chosenInstances : []
  
    return axios.post('', {
      query: `
        mutation {
          updateUser (
            id: ${user.id},
            username: "${user.username}",
            name: "${user.name}",
            image: "${user.image}",
            email: "${user.email}",
            password: "${user.password === null || user.password === undefined ? '' : user.password}",
            role_id: ${user.role.id},
            user_department_id: ${(user.userDepartment)? user.userDepartment.id : null},
            chosen_instances: [${user.chosenInstances.join(',')}],
            `+ (user.allowedToUnify ? `allowed_to_unify: ${user.allowedToUnify},` : '') + `,
          ) {
            user {
              id,
              email,
              name,
              image,
              username,
              isConnected,
              role {
                id,
                name,
                display_name,
                has_permission_routes
              },
              userDepartment {
                id,
                name,
                activated 
              },
              userInstances {
                id,
                name,
                activated
              }
            }
          }
        }
      `
    })
  },
  updatePassword(user) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          updateUserPassword (
            password: "${user.password}"
          ) {
            token,
            user {
              id,
              email,
              name,
              image,
              username,
              isConnected,
              role {
                id,
                name,
                display_name,
                has_permission_routes
              },
              userDepartment {
                id,
                name,
                activated 
              }
            }
          }
        }
      `
    })
  },
  delete(userId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          deleteUser (
            id: ${userId}
          )
        }
      `
    })
  },
  infos() {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          userInfos {
            id,
            email,
            name,
            image,
            username,
            isConnected,
            attempts,
            blocked_at,
            twofactor_activity,
            expiration_password,
            is_two_factor_validated,
            view_banner
            role {
              id,
              name,
              display_name,
              has_permission_routes
            },
            isConnected,
            userDepartment {
              id,
              name,
              activated 
            },
            userInstances {
              id,
              name,
              activated
            }
          }
        }
      `
    })
  },
  fetchInstances(userId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          userInstances (
            user_id: ${userId}
          ) {
            id,
            instance {
              id,
              name,
              activated,
              reset_finished
            }
          }
        }
      `
    })
  },
  connected(ip) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          connected(
            ip : "${ip}"
          )
        }
      `
    })
  },
  disconnected(ip) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          disconnected(
            ip : "${ip}"
          )
        }
      `
    })
  },
  disconnectUser(userId, ip) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          disconnectUser (
            user_id: ${userId},
            ip: "${ip}"
          )
        }
      `
    })
  },
  deleteInstance(userInstanceId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          deleteUserInstance (
            id: ${userInstanceId}
          )
        }
      `
    })
  },
  fetchDiffInstances(removeIds = []) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          instances (
            remove_ids: [${removeIds.join(',')}]
          ) {
            id,
            name,
            nickname,
            activated
          }
        }
      `
    })
  },
  fetchOnlineUsers(
    userId          = null,
    instanceId      = null,
    paginationPage  = 1,
    paginationLimit = 4,
    searchFilter    = '',
    deparmentId     = null
  ) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
    return axios.post('', {
      query: `
        query {
          onlineUsers (
            user_id: ${userId},
            instance_id: ${instanceId},
            pagination_page: ${paginationPage},
            pagination_limit: ${paginationLimit},
            search_filter: "${searchFilter}",
            department_id: ${deparmentId}
          ) {
            pagination_page,
            pagination_limit,
            total_pages,
            total_items,
            items {
              id,
              email,
              name,
              image,
              userDepartment {
                id,
                name
              }
            }
          }
        }
      `
    });
  },  
  unblockUser(userId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
    return axios.post('', {
      query: `
        mutation {
          unblockUser (
            user_id: ${userId}
          ){
            id,
            attempts,
            blocked_at,
          }
        }
      `
    });
  },
  twoFactorActivity(data){
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
    return axios.post('', {
      query: `
        mutation {
          twoFactorActivity (
            validate: "${data.validate}",
            identify: ${data.identify}
            ip: "${data.ip}",
          ){
            id,
            twofactor_activity,
          }
        }
      `
    });
  },
  getUserValidateTwoFatctor(verifyActivity) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          getUserValidateTwoFatctor( 
            verifyActivity: ${verifyActivity}
          ){
            id,
            twofactor_activity,
            google2fa_secret,
            qrCodeSVG
          }
        }
      `
    })
  }, 
  generateQrcode(verifyActivity) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          generateQrcode( 
            verifyActivity: ${verifyActivity}
          ){
            id,
            twofactor_activity,
          }
        }
      `
    })
  },
  updateViewBanner(viewBanner) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
    return axios.post('', {
      query: `
        mutation {
          updateViewBanner (
            view_banner: ${viewBanner}
          )
        }
      `
    });
  },  
}
